<template>
    <d2-container>
        <h2>材料权限分配</h2>
        <el-tabs v-model="activeName" @tab-click="handleClick" ref="tabs">
            <el-tab-pane label="街镇-材料分配" :name="0" :key="activeName" v-if="isPlatform" lazy="true">
                <MaterialComponents :activeName="activeName"></MaterialComponents>
            </el-tab-pane>
            <el-tab-pane label="部门-材料分配" :name="1" :key="activeName">
                <MaterialComponents :activeName="activeName"></MaterialComponents>
            </el-tab-pane>
            <el-tab-pane label="角色-材料分配" :name="2" :key="activeName">
                <MaterialComponents :activeName="activeName"></MaterialComponents>
            </el-tab-pane>
        </el-tabs>


    </d2-container>
</template>
<script>
    import MaterialComponents from './MaterialComponents.vue'
    import {queryStatus} from "../../../api/admin/sysEnterprise/index";
    export default {
        components: {
            MaterialComponents
        },
        data() {
            return {
                activeName:1,
                userStatus:{},
                isPlatform: false,
            };
        },
        created(){
            queryStatus({}).then(response=>{
                this.userStatus = response;
                if(response && response.entType == 3){
                    this.isPlatform = true;
                    this.activeName = 0;
                }
            })
        },
        methods:{
            handleClick:function(tab, event){
                this.$store.commit("authType", tab.name);
            }
        }
    };
</script>
